<template>
    <div class="four-side-css-props text-center">
            <div style="text-align:center;border:1px solid grey;padding:0px; display:inline-block;border-radius:8px;">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <!-- TOP LEFT RADIUS -->
                                <drag-input-unit
                                    :min="0"
                                	:value='styleJSON.borderTopLeftRadius' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="dot-circle"
                                	@input="(value)=>{
                                		if(currentGroup === 2 ) setAllRadius(value);
                                		else {
	                                		setStyle({borderTopLeftRadius:value});
	                                		if(currentGroup === 1){
	                                			setStyle({borderTopRightRadius:value});
	                                		}
                                		}
                                	}" 
                                />
                            </td>
                            <td>
                                <!-- TOP WIDTH -->
                                <drag-input-unit 
                                    :min="0"
                                    :value="styleJSON['borderTopWidth']" 
                                    :style="{background:['white','#fff3b7','lightgrey'][currentGroup]}"
                                    icon="arrows-v" 

                                    @input="(value)=>{
                                        if(currentGroup === 2 ) setAll('Width',value);
                                        else {
                                            setStyle({borderTopWidth:value});
                                            if(currentGroup === 1){
                                                setStyle({borderBottomWidth:value});
                                            }
                                        }
                                    }" 
                                    
                                />
                                
                            </td>
                            <td>
                                <!-- TOP RIGHT RADIUS -->
                                <drag-input-unit
                                    :min="0"
                                	:value='styleJSON.borderTopRightRadius' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="dot-circle"
                                	@input="(value)=>{
                                		if(currentGroup === 2 ) setAllRadius(value);
                                		else {
	                                		setStyle({borderTopRightRadius:value});
	                                		if(currentGroup === 1){
	                                			setStyle({borderTopLeftRadius:value});
	                                		}
                                		}
                                	}" 
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <drag-input-unit 
                                    :min="0"

                                    :value="styleJSON['borderLeftWidth']" 
                                    icon="arrows-h" 
                                    :style="{background:['white','#fcd2ff','lightgrey'][currentGroup]}"

                                    @input="(value)=>{
                                        if(currentGroup === 2 ) setAll('Width',value);
                                        else {
                                            setStyle({borderLeftWidth:value});
                                            if(currentGroup === 1){
                                                setStyle({borderRightWidth:value});
                                            }
                                        }
                                    }" 

                                />
                            </td>
                            <td>
                                <btn 
                                    v-for="(icon,index) in ['expand','compress','square']" 
                                    :key="index"
                                    :icon="icon" 
                                    s="xs" 
                                    :active="currentGroup === index" 
                                    @press="currentGroup = index" 
                                />
                            </td>
                            <td >
                                <drag-input-unit 
                                    :min="0"
                                    :value="styleJSON['borderRightWidth']" 
                                    icon="arrows-h" 
                                    :style="{background:['white','#fcd2ff','lightgrey'][currentGroup]}"
                                    
                                    @input="(value)=>{
                                        if(currentGroup === 2 ) setAll('Width',value);
                                        else {
                                            setStyle({borderRightWidth:value});
                                            if(currentGroup === 1){
                                                setStyle({borderLeftWidth:value});
                                            }
                                        }
                                    }" 
                                />
                            </td>
                        </tr>
                        <tr>

                            <td>
                                <drag-input-unit
                                    :value='styleJSON.borderBottomLeftRadius' 
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                    icon="dot-circle"
                                    @input="(value)=>{
                                        if(currentGroup === 2 ) setAllRadius(value);
                                        else {
                                            setStyle({borderBottomLeftRadius:value});
                                            if(currentGroup === 1){
                                                setStyle({borderBottomRightRadius:value});
                                            }
                                        }
                                    }" 
                                />
                            </td>
                            <td>
                                
                                <drag-input-unit 
                                    :min="0"
                                    :value="styleJSON['borderBottomWidth']" 
                                    :style="{background:['white','#fff3b7','lightgrey'][currentGroup]}"
                                    icon="arrows-v" 
                                    @input="(value)=>{
                                        if(currentGroup === 2 ) setAll('Width',value);
                                        else {
                                            setStyle({borderBottomWidth:value});
                                            if(currentGroup === 1){
                                                setStyle({borderTopWidth:value});
                                            }
                                        }
                                    }" 
                                />
                            </td>

                            <td>
                                <drag-input-unit 
                                    :min="0"
                                	:value='styleJSON.borderBottomRightRadius' 
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                    
                                	icon="dot-circle"
                                	@input="(value)=>{
                                		if(currentGroup === 2 ) setAllRadius(value);
                                		else {
											setStyle({borderBottomRightRadius:value});
		                            		if(currentGroup === 1){
		                            			setStyle({borderBottomLeftRadius:value});
		                            		}
                                		}
                                		
                                	}"
                                />
                             </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <span style="font-size:12px;">Индивидуальная настройка краев</span>

            <color-picker 
                    label="Цвет рамки"
                    :color="styleJSON['borderLeftColor'].value" 
                    @input="(value)=>{setAll('Color', {value})}"
                />
                <list-select
                    :value="styleJSON['borderLeftStyle'].value" 
                    :options='borderStyles' 
                    @input="(value)=>{setAll('Style', {value})}"
                />

            <!-- <inputi type="boolean" :value="individual" @input="(value)=>{individual=value}"/> -->
                <!-- 
            <div v-for='(prop,index) in ["borderLeft","borderTop", "borderRight", "borderBottom"]' v-if='(individual?true:index === 0)'>
                <icon style="width:14px;" :name="['angle-double-left','angle-double-up','angle-double-right','angle-double-down'][index]"/>
                
                <drag-input-unit 
                    :value="styleJSON[prop+'Width']" 
                    icon="arrows-h" 
                    @input="(value)=>{individual?setStyle({[prop+'Width']:value}):setAll('Width', value)}"
                />
                <color-picker 
                    label="Цвет рамки"
                    :color="styleJSON[prop+'Color'].value" 
                    @input="(value)=>{individual?setStyle({[prop+'Color']:value}):setAll('Color', {value})}"
                />
                <list-select
                    :value="styleJSON[prop+'Style'].value" 
                    :options='borderStyles' 
                    @input="(value)=>{individual?setStyle({[prop+'Style']:value}):setAll('Style', {value})}"
                    />
            </div> -->
    </div>
</template>
<script>

import ColorPicker from "./color-picker.vue";

export default {
    name: "border-radius-settings",
    components:{ColorPicker},
    methods:{
    	setAllRadius(value){
            this.setStyle({
                borderTopLeftRadius:value,
                borderTopRightRadius:value,
                borderBottomLeftRadius:value,
                borderBottomRightRadius:value,
            });
        },
        setAll(prop, value){
            console.log(prop,value)
			this.setStyle({
				["borderLeft"+prop]:value,
				["borderRight"+prop]:value,
				["borderTop"+prop]:value,
				["borderBottom"+prop]:value,
			});
    	}
    },
    data() {
        return {
            currentGroup: 0,
            individual:true,
            borderStyles: [
                        {label:"_________", value:"solid"}, 
                        {label:"- - - - -", value:"dashed"},
                        {label:". . . . .", value:"dotted"}] 
        }
    },
    props: {
        prop: String,
        title: String,
        setStyle: Function,
        styleJSON: Object,
        dirs: {
            type: Array,
            default () {
                return [
                    { name: "Left", icon: "angle-left" },
                    { name: "Right", icon: "angle-right" },
                    { name: "Top", icon: "angle-up" },
                    { name: "Bottom", icon: "angle-down" },
                ]
            }
        }
    }
}
</script>
<style scoped>
.btnGroupVertical .btn {
    width: 18px;
}
</style>